var map = {
	"./blog.svg": "8ff4",
	"./campaign.svg": "9431",
	"./campaign_text.svg": "e2e9",
	"./contact.svg": "714d",
	"./contact_text.svg": "7f65",
	"./gallery.svg": "4105",
	"./member.svg": "9a49",
	"./member_text.svg": "c9e8",
	"./recruit.svg": "dcdf",
	"./recruit_text.svg": "762e",
	"./staff.svg": "fcdc",
	"./staff_text.svg": "0b15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7974";